import React, { useEffect, useState } from "react";
import { trendingCategoryData } from "../../data/categories_data";
import Collection_category_filter from "../collections/collection_category_filter";
import CategoryItem from "./categoryItem";
import { useDispatch, useSelector } from "react-redux";
import {
  updateTrendingCategoryItemData,
  updatetrendingProperties,
} from "../../redux/marketplaceSlice";
import {
  getCollectionListings,
  getCollectionsByContract,
  getPalletNfts,
  getCollectionDetail
} from "../../utils/api";
import {
  useCosmWasmClient,
  useSigningCosmWasmClient,
} from "@sei-js/react";
import { BeatLoader } from "react-spinners";
import LoadingComp from "../loading/loading";
import { LISTING_PAGE_COUNT } from "../../config";

const FilterCategoryItem = () => {
  const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();
  const { cosmWasmClient } = useCosmWasmClient();

  const {
    sortedtrendingCategoryItemData,
    singleNftSearchInputInfo,
    trendingCategoryItemData,
    openCollectionFilterModal,
  } = useSelector((state) => state.marketplace);
  const dispatch = useDispatch();
  const [limit, setLimit] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [isShowMoreLoading, setIsShowMoreLoading] = useState(false);
  const [isLoadAll, setIsLoadAll] = useState(false);

  const [collectionInfo, setCollectionInfo] = useState();
  const [listingPage, setListingPage] = useState(0);
  const [palletPage, setPalletPage] = useState(1);

  useEffect(() => {
    const collectionPath = window.location.pathname.split("/")[2];
    const data = { collection: collectionPath, subquery: limit };
    getCollectionsByContract(data).then((data) => {
      console.log("getCollectionsByContract data: ", data);
      setCollectionInfo(data);
    });
  }, []);

  useEffect(() => {
    if (cosmWasmClient) {
      const collection = window.location.pathname.split("/")[2];
      getCollectionDetail(collection).then(detail => {
        console.log('detail = ', detail)
      })

      fetchAllNftData(true)
      // getCollectionListingsCount({collection}).then(async count => {
      //   setListingCount(count)
      //   fetchAllNftData(true)
      // })
    }
  }, [cosmWasmClient]);

  useEffect(() => {
    const temp = [];
    for (let i = 0; i < trendingCategoryItemData.length; i++) {
      if (
        (trendingCategoryItemData[i]?.token_id &&
          trendingCategoryItemData[i]?.token_id
            .toString()
            ?.includes(singleNftSearchInputInfo)) ||
        (trendingCategoryItemData[i]?.name &&
          trendingCategoryItemData[i]?.name?.includes(singleNftSearchInputInfo))
      ) {
        temp.push(trendingCategoryItemData[i]);
      }
    }
    console.log("log : ", trendingCategoryItemData, temp);
    dispatch(updatetrendingProperties({ filterData: temp }));
  }, [singleNftSearchInputInfo]);

  const fetchAllNftData = async (isFetchList) => {
    if (isFetchList) {
      const listings = await getListingData()
      if (listings.length < 15) {
        await fetchPalletData(listings)  
      }
    } else {
      await fetchPalletData([])
    }

    isLoading && setIsLoading(false)
  }

  const getListingData = async () => {
    const listings = await getCollectionListings({collection: window.location.pathname.split("/")[2], subquery: listingPage})
    if (listings.length > 0) {
      const displayListings = listings.reverse().reduce((prev, cur) => {
        if (!cur.offer) {
          const meta = JSON.parse(cur.metadata)
          prev.push( {
            ...cur,
            image: meta.image,
            filter: true,
            title: meta.name
          } )
        }

        return prev
      }, [])

      return displayListings
    }

    return []
  }

  const fetchPalletData = async (listings) => {
    const palletData = await getPalletNfts(window.location.pathname.split("/")[2], palletPage, LISTING_PAGE_COUNT)
    setPalletPage(++palletPage)
    if (palletData && palletData.length > 0) {
      listings.length > 0 ? dispatch(updateTrendingCategoryItemData([...sortedtrendingCategoryItemData,  ...listings, ...palletData])) :
      dispatch(updateTrendingCategoryItemData([...sortedtrendingCategoryItemData, ...palletData]))
    }

    if (!palletData || palletData.length < LISTING_PAGE_COUNT) {
      setIsLoadAll(true)
    }
  }

  const handleShowMore = async () => {
    setIsShowMoreLoading(true)
    await fetchAllNftData(false)
    setIsShowMoreLoading(false)
  }

  return (
    <div>
      <Collection_category_filter collectionInfo={collectionInfo} />
      <div className="flex">
        <div
          className={
            openCollectionFilterModal
              ? "block   w-[520px] collection_modal"
              : "modal fade"
          }
        ></div>

        {isLoading ? (
          <div className="loading_box">
            <LoadingComp />
          </div>
        ) : (
          <div className="w-full min-h-[420px]">
            <CategoryItem
              signingClient={signingClient}
              allNfts={sortedtrendingCategoryItemData}
            />

            {!isLoadAll ? <div className="text-center pb-[80px] pt-[20px]">
              {
                isShowMoreLoading ? 
                <BeatLoader
                  color="#fff"
                  loading={isShowMoreLoading}
                  size={10}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                /> : <button onClick={handleShowMore}>Show More</button>
              }
            </div> : 
            <div className="h-[80px]">
            </div>}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterCategoryItem;
